import React from "react";
import styled from "@emotion/styled";

import { useTheme } from "../../contexts/themeContext";
import { logistic } from "../../utils/undraw_logistics_x4dc";

function Footer() {
  const theme = useTheme();

  return (
    <FooterStyled bgColor={theme.mainPink}>
      <FooterLayout color={theme.mainDark}>
        <div>
          <h3>damecalvofficial@yahoo.com</h3>
          <h3>+373 69 177 909</h3>
        </div>
        {logistic}
      </FooterLayout>
      <Copyright color={theme.mainDark}>
        &copy; {new Date().getFullYear()} Dameca LV all rights Reserved{" "}
      </Copyright>
    </FooterStyled>
  );
}

const FooterStyled = styled.footer`
  width: 100%;
  background: red;
  position: sticky;
  display: flex;
  align-items: center;
  background: ${props => props.bgColor};
  padding: 50px 0 0;
  flex-direction: column;
  font-family: "Helvetica Neue", sans-serif;
`;

const FooterLayout = styled.div`
  display: flex;
  width: 30%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 500px) {
    width: 70%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 40%;
    height: auto;
  }

  h3 {
    font-family: "Helvetica Neue", sans-serif;
    font-size: 15px;
    text-align: justify;
    text-justify: inter-word;
    margin-bottom: 10px;
    color: ${props => props.color};
    text-align: center;
  }
`;

const Copyright = styled.div`
  width: 30%;
  text-align: center;
  margin: 50px 0 30px;
  font-size: 15px;
  color: ${props => props.color};

  @media (max-width: 500px) {
    width: 70%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export default Footer;
